import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
export default function SaveReplace(props) {
    const {t} = useTranslation('slotAssignment');

    const choices = [t('create'), t('update')];

    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
        <DialogTitle style={{textAlign: 'center'}}>{t('create_or_update')}</DialogTitle>
        <List>
            {choices.map((choice) => (
            <ListItem button onClick={() => handleListItemClick(choice)} key={choice}>
                <ListItemText primary={choice} style={{textAlign: 'center'}}/>
            </ListItem>
            ))}
        </List>
        </Dialog>
    );
}

SaveReplace.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};